import React from 'react';
import { StyledTooltip } from './components/styledTooltip';
import { TooltipProps } from './model';
import { RIGHT_ARROW_PROPS } from './const';
export type { TooltipProps } from './model';
export { TooltipTokens } from './components/styledTooltip';

export const Tooltip: React.FC<TooltipProps> = (props) => {
  const { children, colorSchema = 'dark', bordered = false, ...otherProps } = props;
  const ownerState = {
    colorSchema,
    bordered,
  };

  return (
    <StyledTooltip
      ownerState={ownerState}
      {...otherProps}
      slotProps={{
        arrow: otherProps.placement?.includes('end') ? RIGHT_ARROW_PROPS : undefined,
        ...otherProps.slotProps,
      }}
    >
      {children}
    </StyledTooltip>
  );
};
